import { getQuery } from '@/common/const';
import { logger } from '@/common/log';
import { afterPv } from '@/common/utils/afterPv';

export const logClickCommentReviewsList = ({ click_type, comment }) => {
    const item_id = getQuery('itemId');
    const { commentId, videoList } = comment;
    const photo_id = videoList?.[0]?.videoId;
    logger.sendClick({
        action: 'CUSTOMER_REVIEWS_LIST',
        params: {
            click_type,
            comment_id: commentId,
            item_id,
            photo_id,
        },
    });
};

export const logClickRate = (star_level: number) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'STAR_LEVEL_COMMENT_PANEL',
            params: {
                star_level: `${star_level}`,
            },
        });
    });
};

export const logClickTab = tab_name => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'CUSTOMER_REVIEWS_TAB',
            params: {
                tab_name,
            },
        });
    });
};

export const logShowMoreRatesButton = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'MORE_RAETES_BUTTON',
        });
    });
};

export const logClickMoreRatesButton = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'MORE_RAETES_BUTTON',
        });
    });
};
